<nz-spin [nzTip]="'LOADING' | translate" [nzSpinning]="isSpinning">
  <div class="financial-component w-full mx:flex mx:p-y-8 sm:p-y-4">
  <!--信用额度-->
      <div class="credit_limit mx:h-[680px] mx:w-[360px] sm:w-full">
        <p class="flex-between"><span class="font-bold">{{"CREDIT_LIMIT" | translate}}</span></p>
        <p class="flex-between"><span>{{"CREDIT_ACCOUNT" | translate}}</span><span class="text-greyDisable">{{creditObj.payer}}</span></p>
        <p class="flex-between"><span>{{"NEXT_REVIEW" | translate}}</span><span class="text-greyDisable">{{creditObj.nextReviewDate}}</span></p>
        <p class="flex-between"><span>{{"CREDIT_LIMIT_AVAILABLE" | translate}}</span><span class="text-greenBosch">{{creditObj.creditLimitAvailable}}</span></p>
        <p class="flex-between"><span>{{"ACTUAL_CREDIT" | translate}}</span><span class="text-greyDisable">{{creditObj.actualCredit}}</span></p>
        <p class="flex-between"><span>{{"PRE_PAY_VALUE" | translate}}</span><span class="text-greyDisable">{{creditObj.prePayValue}}</span></p>
        <p class="flex-between"><span>{{"OVERDUE" | translate}}</span><span class="font-bold"  [ngClass]="{
          'text-red': creditObj.overdue !== '0.00',
          'text-greyDisable': creditObj.overdue === '0.00'
        }"> CNY {{creditObj.overdue | number: '1.2-2'}}</span></p>
      </div>
      <div class="mx:w-[calc(100%-392px)] result-table">
        <form [formGroup]="searchFormData">
          <div class="flex w-full flex-wrap gap-x-4 sm:flex-col">
            <div class="sm:w-full mx:w-[516px] sm:mt-4" >
              <nz-form-item class="search-form-item">
                <nz-form-control>
                  <div class="flex">
                    <div class="mx:w-[250px] sm:w-[50%]">
                      <nz-select class="bosch-select" formControlName="keywordsType" (ngModelChange)="changeKeywords()"
                      [nzSuffixIcon]="suffixSearch">
                      <nz-option *ngFor="let item of codeTypeList; let i = index" [nzValue]="item.value"
                        [nzLabel]="item.name"></nz-option>
                    </nz-select>
                      <ng-template #suffixSearch><i class="search-arrow"></i></ng-template>
                    </div>
                    <div class="mx:w-[250px] ml-4">
                      <nz-input-group class="bosch_input" [nzSuffix]="suffixTemplateInfo"  >
                      <input (keydown.enter)="onInputEnter($event)"  nz-input type="text"  formControlName="keywords" [placeholder]="'INPUT_PLACEHOLDER' | translate" />
                      <ng-template #suffixTemplateInfo>
                        <i class="search" (click)="handleChange($event)"></i>
                      </ng-template>
                    </nz-input-group>
                    </div>
                  </div>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div class="sm:w-full mx:w-[250px]">
              <nz-form-item class="search-form-item">
                <nz-form-control>
                  <nz-select class="bosch-select" formControlName="orderStatus" nzAllowClear [nzPlaceHolder]="'ORDER_STATUS' | translate" (ngModelChange)="handleChange($event)" [nzSuffixIcon]="suffixSearch">
                    <nz-option *ngFor="let item of statusList; let i = index" [nzValue]="item.value" [nzLabel]="item.name">
                    </nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div class="sm:w-full mx:w-[250px]">
              <nz-form-item class="search-form-item">
                <nz-form-control>
                  <nz-range-picker class="w100 bosch-date-picker" formControlName="dueDate"  (ngModelChange)="handleChange($event)" [nzSuffixIcon]="suffixDate"></nz-range-picker>
                </nz-form-control>
                <ng-template #suffixDate><i class="search-date"></i></ng-template>
              </nz-form-item>
            </div>
            <div class="sm:w-full mx:w-[104px] flex">
              <button nz-button nzType="text" class="clear flex justify-center"  (click)="clear()">
                <svg-icon [iconName]="'new/close-blue.svg'" [size]="20" ></svg-icon> {{"CLEAR" | translate}}
              </button>
            </div>
            <div class="sm:w-full mx:w-[76px] flex">
              <button nz-button nzType="text" class="mt-2" (click)="exportExcel()" [nzLoading]="exportLoading">
                <svg-icon [iconName]="'new/download.svg'" ></svg-icon> {{ "EXPORT" | translate}}
              </button>
            </div>
          </div>
        </form>
        <nz-table
        #fixedTable [nzScroll]="{ x: 'max-content'}"
        [nzShowPagination]="false"
        [nzFrontPagination]="false"
        [nzData]="financialListData"
        [nzTotal]="pagination.total"
        [nzPageIndex]="pagination.pageIndex"
        [nzPageSize]="pagination.pageSize"
        [nzPageSizeOptions]="pagination.pageSizeOptions"
        (nzPageIndexChange)="pageIndexChange($event)"
        (nzPageSizeChange)="pageSizeChange($event)"
        >
        <thead>
          <tr>
            <th nzWidth="155px">{{"DELIVERY_NOTE" | translate}}</th>
            <th nzWidth="170px">{{"REFERENCE_INVOICE" | translate}}</th>
            <th nzWidth="160px">{{"PAY_DUE_DATE" | translate}}</th>
            <th nzWidth="200px">{{"AMOUNT_IN_LOCAL_CURRENCY" | translate}}</th>
            <th nzWidth="140px">{{"ORDER_TEXT" | translate}}</th>
            <th nzWidth="114px">{{"OVERDUE_DAYS" | translate}}</th>
            <th nzWidth="120px" >{{"STATUS" | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of financialListData">
            <td nzBreakWord>
              <div *ngFor="let note of data.deliveryNote.split(',')">{{ note }}</div>
              
            </td>
            <td nzBreakWord> {{ data.invoice }}</td>
            <td>{{ data.dueDate }}</td>
            <td>{{ data.amountDisplay }}</td>
            <td>{{ data.text }}</td>
            <td>{{ data.overDueDays }}</td>
            <td><div  [ngClass]="{
              'overdue': data.status === 'OverDue'|| data.status === '已超期',
              'due': !(data.status === 'OverDue'|| data.status === '已超期')
            }"> {{data.status}}</div></td>
              
          </tr>
        </tbody>
      </nz-table>
      <ng-template #totalTemplate let-total>{{
        "TOTAL_ITEM" | translate : { total }
      }}</ng-template>
    
      </div>
  </div>  
</nz-spin>

